import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class TransportationEntryService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }
	loadShipmentsTypeDropDown(): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/shipments/getShipmentTypes`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}
	addTransportationEntry(userId, addObject): Observable<any> {
		return this.http.post(` ${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/getTransportationEntry/addEditTransporatationEntry/${userId}`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updateTransportationEntry(updateObject): Observable<any> {
		return this.http.put(` ${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/updateTransportationEntry`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	loadDataTransportationEntry(): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/getTransportationEntry`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	loadDataTransportationEntryAssignee(TEID,shipmentTypeID): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/getTransportationAssignedInvoices/${TEID}/${shipmentTypeID}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)).toPromise();
	}
	loadDataTransportationEntryUnassignee(shipmentTypeID): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/getTransportationUnAssignedInvoices/${shipmentTypeID}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)).toPromise();
	}
	loadDataTransportationEntryDetails(TEID): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/getTransportationEntryDetails/${TEID}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}


	updateNewInvoiceAssignee(TEID, invoiceIds): Observable<any> {
		return this.http.put(` ${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/assignInvoicesTransportation/${TEID}/${invoiceIds}`, {}, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	updateNewInvoiceUnassignee(invoiceIds): Observable<any> {
		return this.http.put(` ${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/unAssignInvoicesTransportation/${invoiceIds}`, {}, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	deleteTransportationEntry(TEID): Observable<any> {

		return this.http
			.delete(`${this.constantsService.baseAPIURL}/export/DocumentControl/TransportationEntry/deleteTransportationEntry/${TEID}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}


}
